
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-wifi",
  "use": "icon-material-wifi-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-wifi\"><path d=\"M480-127q-36 0-63-27t-27-63 27-63 63-27 63 27 27 63-27 63-63 27M235.83-353.17 169-419.76q70-70 146.5-105.12T480-560t164.5 35T791-420l-66.83 66.83q-61-60.53-121.56-85.93-60.57-25.4-122.61-25.4t-122.61 25.4q-60.56 25.4-121.56 85.93m-169-169L0-589q93-95 216.5-153T480-800t263.5 58T960-589l-66.83 66.83q-88-83.29-190.94-132.81Q599.28-704.5 480-704.5t-222.23 49.52Q154.83-605.46 66.83-522.17\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-wifi"/>
                </svg>
            );
        };

        Icon.id = "icon-material-wifi";

        export default Icon;
    